"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DevicesPage = DevicesPage;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var react_router_dom_1 = require("react-router-dom");
var devices_1 = require("../components/dashboard/devices");
var pagination_1 = require("../constants/pagination");
var routes_1 = require("../constants/routes");
var device_1 = require("../features/apis/device");
var use_sort_descriptor_1 = require("../hooks/use-sort-descriptor");
var hooks_1 = require("../store/hooks");
var client_scoped_query_1 = require("../utils/client-scoped-query");
var facility_scoped_query_1 = require("../utils/facility-scoped-query");
var paginated_content_1 = require("../utils/paginated-content");
var use_debounce_1 = require("../utils/use-debounce");
var use_has_permission_1 = require("../utils/use-has-permission");
function DevicesPage() {
    var _this = this;
    var _a, _b, _c;
    var clientId = (0, client_scoped_query_1.useActiveClientId)();
    var facilityId = (0, facility_scoped_query_1.useActiveFacilityId)();
    var navigate = (0, react_router_dom_1.useNavigate)();
    var userId = (0, hooks_1.useAppSelector)(function (state) { var _a; return (_a = state.user.user) === null || _a === void 0 ? void 0 : _a._uid; });
    var canCreateDevices = (0, use_has_permission_1.useHasPermission)("create_devices");
    var canUpdateDevices = (0, use_has_permission_1.useHasPermission)("update_devices");
    var _d = (0, react_1.useState)(pagination_1.DEFAULT_PAGE_NUMBER), page = _d[0], setPage = _d[1];
    var resetPage = (0, react_1.useCallback)(function () { return setPage(pagination_1.DEFAULT_PAGE_NUMBER); }, []);
    var _e = (0, use_sort_descriptor_1.useSortDescriptor)(resetPage), sortDescriptor = _e.sortDescriptor, onSortChange = _e.onSortChange, sortBy = _e.sortBy, sortDirection = _e.sortDirection;
    var _f = (0, react_1.useState)(pagination_1.DEFAULT_PAGE_SIZE), pageSize = _f[0], setPageSize = _f[1];
    var _g = (0, react_1.useState)(false), isAddModalOpen = _g[0], setIsAddModalOpen = _g[1];
    var _h = (0, react_1.useState)(undefined), togglingDeviceId = _h[0], setTogglingDeviceId = _h[1];
    var _j = (0, react_1.useState)(""), search = _j[0], setSearch = _j[1];
    var debouncedSearch = (0, use_debounce_1.useDebouncedValue)(search);
    var _k = (0, device_1.useGetDevicesQuery)({
        clientId: clientId,
        facilityId: facilityId,
        userId: userId !== null && userId !== void 0 ? userId : "",
        size: pageSize,
        pageNumber: page,
        search: debouncedSearch || undefined,
        sortBy: sortBy,
        sortDirection: sortDirection,
    }, { skip: !facilityId }), currentData = _k.currentData, isLoading = _k.isLoading, isFetching = _k.isFetching, isError = _k.isError, error = _k.error, refetch = _k.refetch;
    var setDeviceAlarms = (0, device_1.useSetDeviceAlarmsMutation)()[0];
    (0, react_1.useEffect)(function () {
        setPage(pagination_1.DEFAULT_PAGE_NUMBER);
    }, [clientId, facilityId, debouncedSearch, pageSize]);
    var devices = (0, paginated_content_1.getContentItems)(currentData);
    var totalDevices = (_c = (_b = (_a = currentData === null || currentData === void 0 ? void 0 : currentData.content) === null || _a === void 0 ? void 0 : _a.pagination) === null || _b === void 0 ? void 0 : _b.totalItems) !== null && _c !== void 0 ? _c : devices.length;
    var handleToggleAlarms = function (device) { return __awaiter(_this, void 0, void 0, function () {
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    setTogglingDeviceId(device.id);
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, setDeviceAlarms({ id: device.id, alarms: !device.alarms }).unwrap()];
                case 2:
                    _b.sent();
                    return [3 /*break*/, 5];
                case 3:
                    _a = _b.sent();
                    return [3 /*break*/, 5];
                case 4:
                    setTogglingDeviceId(undefined);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    return ((0, jsx_runtime_1.jsxs)("div", { className: "flex flex-col gap-4", children: [(0, jsx_runtime_1.jsx)(devices_1.DevicesHeader, { search: search, onSearchChange: setSearch, onAddDevice: function () { return setIsAddModalOpen(true); }, canAddDevice: canCreateDevices }), (0, jsx_runtime_1.jsx)(devices_1.DevicesTable, { devices: devices, isLoading: isLoading || !facilityId || (isFetching && !currentData), isFetching: isFetching, isError: isError, error: error, onRetry: refetch, onView: function (device) { return navigate((0, react_router_dom_1.generatePath)(routes_1.ROUTES.DEVICE_VIEW, { id: device.id })); }, onToggleAlarms: handleToggleAlarms, togglingDeviceId: togglingDeviceId, canToggleAlarms: canUpdateDevices, sortDescriptor: sortDescriptor, onSortChange: onSortChange, page: page, pageSize: pageSize, total: totalDevices, onPageChange: setPage, onPageSizeChange: setPageSize }), (0, jsx_runtime_1.jsx)(devices_1.AddDeviceModal, { isOpen: isAddModalOpen, clientId: clientId, userId: userId, onClose: function () { return setIsAddModalOpen(false); }, onCreated: refetch })] }));
}
